/** Represents an error reported by the mingo library. */
export class MingoError extends Error {
}
